import { useAtomValue } from 'jotai'
import { layerMetadataAtom } from '@app/domains/layers/state/layers.atoms'

/**
 * Extracts the semantic ID from a versioned layer ID.
 * "h174_l5_v4" → "h174"
 * "e279_l0_v6" → "e279"
 */
const getSemanticId = (versionedId: string): string => versionedId.split('_')[0]

export function useLayerLookup() {
  const layerMetadata = useAtomValue(layerMetadataAtom)

  /**
   * Resolves a versioned layer ID to its display title.
   * Falls back to the raw ID if not found.
   */
  const getTitle = (versionedId: string): string => {
    const semanticId = getSemanticId(versionedId)
    return layerMetadata.find((m) => m.id === semanticId)?.title ?? versionedId
  }

  /**
   * Resolves multiple versioned IDs to { id, title } pairs.
   */
  const resolveAll = (versionedIds: string[]) =>
    versionedIds.map((id) => ({ id, title: getTitle(id) }))

  return { getTitle, resolveAll }
}
